import './styles.scss';
import {makeCaptchaToken} from "./captcha/recaptcha-v3";

class ContactForm extends HTMLElement {
    connectedCallback() {
        const formEl = this.querySelector('form')!;
        const submitRoute = formEl.getAttribute('action')!;
        const overlayEl = this.querySelector('loading-overlay')!;

        formEl.addEventListener('submit', (e): void => {
            e.preventDefault();
            overlayEl.removeAttribute('hidden');

            this.populateCaptchaField()
                .then((t) => {
                    const options = {
                        method: 'POST',
                        body: new FormData(formEl),
                        headers: {
                            'X-SSR': 'true',
                            'X-Requested-With': 'XMLHttpRequest',
                        }
                    };

                    fetch(submitRoute, options)
                        .then(response => {
                            if (response.ok === false) {
                                throw new Error(`Form block SSR failed: ${response.statusText}`);
                            }

                            return response.text();
                        })
                        .then((response): void => {
                            const parentElement = this.parentElement;

                            this.outerHTML = response;
                            overlayEl.setAttribute('hidden', 'hidden');

                            if (parentElement) {
                                parentElement.scrollIntoView();
                            }
                        })
                        .catch(error => {
                            console.error(error);
                            // Fallback to regular form submission

                            this.populateCaptchaField()
                                .then(() => {
                                    formEl.submit();
                                })
                        })
                })
        });
    }

    protected populateCaptchaField(): Promise<void> {
        const formEl = this.querySelector('form')!;
        const captchaKey = this.getAttribute('recaptcha-site-key');

        if (captchaKey === null) {
            throw new Error('CAPTCHA key is missing');
        }

        return makeCaptchaToken(captchaKey)
            .then((token: string) => {
                formEl.querySelector<HTMLInputElement>('input[name="captcha_token"]')!.value = token;
            });
    }

}

customElements.define('contact-form', ContactForm);
